import React, { useMemo } from 'react';
import { useAsync } from '@maxtropy/components';
import { getDeviceTypeTree } from '@/api/deviceType';
import { DeviceType } from '@/shared/types';
import { uniqBy } from 'lodash-es';

// 设备类型级联选择器数据
export const useDeviceTypeCascaderOptions = () => {
  const deviceTypeData = useAsync(getDeviceTypeTree);
  return useMemo(() => {
    const tree = deviceTypeData?.tree ?? [];
    const list = tree.reduce<DeviceType[]>((prev, curr) => {
      return [...prev, ...(curr?.deviceTypes ?? [])];
    }, []);
    const uniqList = uniqBy(list, 'id');
    return uniqList.map(m => ({
      label: m.name,
      value: m.id,
      children: m.children?.map(item => ({
        ...item,
        label: item.name,
        value: item.id,
      })),
    }));
  }, [deviceTypeData?.tree]);
};
